import React from "react";

interface SuraLogoImageProps {
  size: "lg" | "md" | "sm";
  logoColor: "blue" | "white";
}

const SuraLogoImage = ({ size, logoColor }: SuraLogoImageProps) => {
  let svgWidth: number;
  let svgHeight: number;
  switch (size) {
    case "lg":
      svgWidth = 67;
      svgHeight = 69;
      break;
    case "md":
      svgWidth = 34;
      svgHeight = 35;
      break;
    case "sm":
      svgWidth = 17.5;
      svgHeight = 18;
      break;
    default:
      svgWidth = 0;
      svgHeight = 0;
      break;
  }

  let logoShade = logoColor === "blue" ? "#0E5AE1" : "white";

  return (
    <svg
      width={svgWidth}
      height={svgHeight}
      viewBox="0 0 67 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2837_52138)">
        <path
          d="M67.2514 0H0V31.6139V34.3801H21.2741V21.3668H67.2514V0Z"
          fill={logoShade}
        />
        <path
          d="M0 69.6436H67.2514V37.0693V35.291H46.0038V48.3098H0V69.6436Z"
          fill={logoShade}
        />
      </g>
      <defs>
        <clipPath id="clip0_2837_52138">
          <rect width="67" height="69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SuraLogoImage;
